import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiUserDataService } from '../fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-contact-action',
    template: `
        @if (!isNewAddButtonLayout) {
          @if (isMainContact) {
            <button
              mat-button
              type="button"
              class="contacts-action-container BrandedColorHover"
              (click)="addNewPhoneContact()"
              >
              <span class="fas fa-plus"></span>
              <span>{{ 'common.add_more' | fiAppText }}</span>
            </button>
          }
          @if (isDeleteEnabled()) {
            <button
              mat-button
              type="button"
              class="contacts-action-container BrandedColorHover"
              (click)="deleteContact()"
              >
              <span class="fas fa-trash-alt"></span>
              <span>{{ 'common.delete' | fiAppText }}</span>
            </button>
          }
        }
        
        @if (isNewAddButtonLayout) {
          @if (isMainContact) {
            <button
              mat-icon-button
              matRipple
              type="button"
              class="BrandedColorHover contacts-action-container icon-button"
              (click)="addNewPhoneContact()"
              >
              <span class="fas fa-circle-plus"></span>
            </button>
          }
          @if (isDeleteEnabled()) {
            <button
              mat-icon-button
              matRipple
              type="button"
              class="delete-contact-button contacts-action-container icon-button"
              (click)="deleteContact()"
              >
              <span class="fas fa-trash-alt"></span>
            </button>
          }
        }
        `,
    styleUrls: ['./fi-contact-action.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-contact-action' },
    standalone: false,
})
export class FiContactActionComponent {
    @Input() isMainContact: boolean;
    @Input() isEditDisabled: boolean;
    @Input() isNewAddButtonLayout: boolean;
    @Input() isSystemObject: boolean;
    @Output() onAddNewContact: EventEmitter<void> = new EventEmitter<void>();
    @Output() onDeleteContact: EventEmitter<void> = new EventEmitter<void>();

    constructor(private userDataService: FiUserDataService) {}

    isDeleteEnabled(): boolean {
        if (this.isSystemObject) return true;
        return !this.isMainContact && !this.isEditDisabled;
    }

    addNewPhoneContact() {
        this.onAddNewContact.emit();
    }

    deleteContact() {
        this.onDeleteContact.emit();
    }
}
